import { Route } from '@angular/router';
import {
  OrganisationAction,
  OrganisationOffer,
  OrganisationStatus,
  OrganisationType,
  ProfileStatus,
} from '@fairandsmart/types';
import { ConfirmDialogData } from '@Common/confirm-dialog/confirm-dialog.component';
import { ORG_PREFIX } from '@Common/constants';
import { cguGuard } from '@Guards/cgu.guard';
import { authenticatedGuard, authenticatedMatchGuard } from '@Guards/authenticated.guard';
import { unauthenticatedGuard } from '@Guards/unauthenticated.guard';
import { customizationGuard, customizationMatchGuard } from '@Guards/customization.guard';
import { FsOrgCustomization } from '../environments/fs-org-environment';
import { WelcomePageComponent } from './components/connection-pages/welcome-page/welcome-page.component';
import { HomePageComponent } from './components/home/home-page/home-page.component';

export interface FsOrgRouteData {
  profileStatus?: ProfileStatus[];
  statuses?: OrganisationStatus[];
  offers?: OrganisationOffer[];
  types?: OrganisationType[];
  actions?: OrganisationAction[];
  helpLabels?: string[];
  preload?: 'acl' | 'authenticated' | 'always';
  unauthenticatedRedirect?: string[];
  keycloakRedirect?: string;
  customization?: Partial<FsOrgCustomization>;
  prompt?: ConfirmDialogData;
  enforceConsentManagerAvailability?: boolean;
}

export interface FsOrgRoute extends Route {
  data?: FsOrgRouteData;
  children?: FsOrgRoutes;
}

export type FsOrgRoutes = FsOrgRoute[];

export const ROUTES: FsOrgRoutes = [
  {
    path: '',
    component: WelcomePageComponent,
    canActivate: [unauthenticatedGuard, customizationGuard],
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomePageComponent,
    canActivate: [authenticatedGuard, cguGuard],
    data: {
      unauthenticatedRedirect: ['/'],
    },
  },
  {
    path: 'create',
    loadChildren: () => import('./components/organisation/creation/organisation-creation.routes').then((m) => m.ROUTES),
    canMatch: [authenticatedMatchGuard, customizationMatchGuard],
    canActivate: [cguGuard],
    data: {
      keycloakRedirect: 'register',
      customization: {
        allowOrganisationCreation: true,
      },
    },
  },
  {
    path: 'invite',
    loadComponent: () => import('./components/connection-pages/membership-invitation/membership-invitation.component').then((m) => m.MembershipInvitationComponent),
    canActivate: [cguGuard],
  },
  {
    path: ORG_PREFIX,
    loadChildren: () => import('./components/organisation/organisation.routes').then((m) => m.ROUTES),
    canActivate: [authenticatedGuard, cguGuard],
    data: {
      preload: 'authenticated',
    },
  },
  { path: '**', redirectTo: '' },
];
